export default __webpack_public_path__ + "static/media/previous_top_talent_status.1da45c52.svg";